import React , { useState, useEffect } from "react";
import {ItemDefault} from '../Products/Item'
import {getBrand} from "../../service/biboMartService";
import {getMetaBrand,getProductByBrand} from "../../service/myProductService";
// import Head from "../Head";
import { useLocation } from '@reach/router';
import Breadcrumbs from '../Breadcrumbs';
import loadScript from '../Layout/loadScript';
import ReactHtmlParser from 'react-html-parser';

import './brand.css';
import { pushtracking } from "../../service/trackingService";
const Brand =()=>{
    const location = useLocation();
    let uri = location.pathname?.replace('.html','').replace('/','');
    var [productList, setProductList] = useState([]);
    const [loadMoreStart, setLoadMoreStart] = useState(0);
    const [totalPage, setTotalPage] = useState(0);
    const [meta, setMeta] = useState([]);
    const [showDes, setShowDes] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const loadBrand = (_uri)=>{
        try{
         getMetaBrand(_uri).then((response)=>{
                if(+response.status === 200){
                    // if(response.message.length > 0){
                        // response.items[0]['meta_url']=window.location.href;
                        // response.items[0]['meta_site']=window.location.host;
                        setMeta(response['message']);
                        window.localStorage.setItem('nameCategory',response['message']?.name);
                    // }
                }
            });
        }catch(e){console.log(e)}
    }

    const loadProductOnBrand=async (uri, page, pagesize)=>{
    try{
        await getProductByBrand(page, pagesize, uri).then((response)=>{
        if(+response.status===200){
          var _item =[];
          var _item_list = [];
          response.message?.forEach((item)=>{
            // item['price']={
            //     raw: item.raw,
            //     discount: item.discount
            // }
            // item['linksp']= item.linksp.replace('https://bibomart.com.vn','');
            // _item.push(item);

            
            _item_list.push({ 
                item_id: item.sku,
                item_name: item.name,
                price: +item.raw
            });
          })
          setTotalPage(response.metadata.total_page);
          setProductList((prevData) => [...prevData, ...response.message]);  
          setShowAlert(true); 
          window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'view_item_list',
                    'ecommerce': {
                        'items': _item_list
                    }
                });
                try{
                    pushtracking(window.localStorage.getItem('sessionId')??null,
                    window.localStorage.getItem('_id')??null,
                    window.localStorage.getItem('phone')??null ,
                    location.pathname, "Thương hiệu", 0,0,'index','inWeb',[],'Website PC').then((response)=>{
                        console.log('send tracking');
                    });
                }catch(e){console.log(e)}
        }
      });
    }catch(e){console.log(e)}
  }
  const handleLoadMore = (e) => {
    const newStart = loadMoreStart + 1;
    if(totalPage >= newStart){
      setLoadMoreStart(newStart);
      loadProductOnBrand(uri,newStart, 24);
    }
    if(+totalPage === +newStart){
      e.target.disabled = true;
    }
  };

    useEffect(()=>{
        loadBrand(uri);
        setProductList([]);
        setTotalPage(0);
        setLoadMoreStart(1);
        loadProductOnBrand(uri,0, 24);
    },[]);
    const toggleShowMore = () => {
        setShowDes(!showDes);
        if(showDes){
        window.scrollTo(0,700)
        }
    }
    return (
        <>
    {/* <Head key="Head" item={meta}/> */}
    <div className="container page-builder-ltr ">
        <div className="container-menu">
            <Breadcrumbs key="Breadcrumbs"
            crumbs={[
                { link: '/', label: 'Trang chủ' },
                { label: window.localStorage.getItem('nameCategory') },
            ]}
            />
        </div>
    </div> 
    <div className="container page-builder-ltr brand">
        <div className='pag-listitem'>
            <div className='row item-header mgx-0'>
                {/* <h1 className="d-none">{window.localStorage.getItem('nameCategory')}</h1> */}
                <div className='col-md-10'><span className='text-baby uppercase'>{window.localStorage.getItem('nameCategory')}</span></div>
                    <div className='col-md-1'><span>Sắp xếp</span></div>
                    <div className='col-md-2 '>
                        <select>
                            <option>
                            Phổ biến nhất
                            </option>
                        </select>
                    </div>
                </div>
                <div className='row item-category-product mgx-0'>
                    <div className="wap-listing-tabs products-list grid">
                        <div className="ltabs-items-container">
                            <div className="products-list ltabs-items">
                                <div className="ltabs-items-inner">
                                    { 
                                        productList?.length > 0 ?(
                                            productList?.map((item, index)=>(
                                                <div className='col-md-2 boder-list' key={index}>
                                                <ItemDefault key={index} item={item} index={index} isShowAddToCart={true} isShowCategoryName={true}/>
                                                </div>
                                            ))
                                        ):(
                                            showAlert === true && productList?.length <= 0 ?(
                                                <div className='message pdr-10'>
                                                    <div className='info'>
                                                    <i className="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i> <span>Không có sản phẩm phù hợp.</span>
                                                    </div>
                                                    
                                                </div>
                                            ):(<div id="landing-web">
                                                <div className="loading-page"  style={{textAlign:"center"}}>
                                                    <img src="/../images/loading.gif" alt="icon"/>
                                                </div>
                                            </div>)
                                        )
                                        
                                    }
                                </div>
                            </div>
                            {
                                productList.length > 0 && +productList[0].total_page > 1 ? (
                                    <>
                                    <div className="col-md-12 ltabs-loadmore">
                                        <button className="btn-loadmore" id="loadmore" data-label="Load More" onClick={(e)=>handleLoadMore(e)} >
                                        <span className="ltabs-image-loading"></span>Xem thêm </button>
                                    </div>
                                    </>
                                ):(null)
                            }

                            <div className="col-md-12 mgt-20">
                                <div className="description">
                                    {showDes ? ReactHtmlParser(meta?.description) : ReactHtmlParser(meta?.description?.substring(0, 600))}
                                </div>

                                {meta?.description?.length > 600 && (
                                    <div className="row text-center">
                                    <a onClick={toggleShowMore}>
                                        <i className={showDes ? "fa fa-angle-up pdr-5" : "fa fa-angle-down pdr-5"}></i>
                                        {showDes ? "THU NHỎ" : "XEM THÊM"}
                                    </a>
                                    </div>
                                )}
                            </div> 
                        </div>
                    </div>
                </div>
        </div>
        </div>
        </>
    );
}

export default Brand